import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';

import { colors } from 'styles/colors';
import Footer from './Footer';

const MainTemplate = ({ children, background }) => (
   <Wrapper background={background}>
      <Content>{children}</Content>
      <Footer />
   </Wrapper>
);

MainTemplate.propTypes = {
   children: PropTypes.node.isRequired,
   background: PropTypes.oneOf(['white', 'neutral', 'dark'])
};

MainTemplate.defaultProps = {
   background: 'neutral'
};

const Wrapper = styled.div`
   display: flex;
   flex-direction: column;
   min-height: 100vh;
   background-color: ${colors.neutral60};

   ${({ background }) =>
      background === 'white' &&
      css`
         background-color: ${colors.white};
      `}

   ${({ background }) =>
      background === 'dark' &&
      css`
         background-color: ${colors.neutral70};
      `}
`;

const Content = styled.div`
   display: block;
   width: 100%;
   flex: 1;
`;

export default MainTemplate;
